import * as React from 'react';
import { useHashNavigation } from '@grandvisionhq/utils';
import { useDrawer } from '../context/DrawerContext.js';

const useDrawerHashNavigation = ({ drawerHash  })=>{
    const { isOpen , open  } = useDrawer();
    const { hash , clearHash  } = useHashNavigation();
    const previousIsOpen = React.useRef(isOpen);
    React.useEffect(()=>{
        if (!hash) {
            return;
        }
        if (hash.includes(drawerHash) && previousIsOpen.current === false) {
            open();
        }
        // we need to check previous value of isOpen for clean up of hash in the url
        if (hash.includes(drawerHash) && previousIsOpen.current === true) {
            clearHash();
        }
        previousIsOpen.current = isOpen;
    }, [
        clearHash,
        drawerHash,
        hash,
        isOpen,
        open
    ]);
};

export { useDrawerHashNavigation };
//# sourceMappingURL=use-drawer-hash-navigation.js.map
